import React, { useState, useEffect } from "react";
import "./Header2.css";

import ThIcon from "../../pics/th_icon.png";
import EnIcon from "../../pics/en_icon.png";
import Logo from "../../pics/RIHES-Logo1.png";

const Header2 = () => {
  const [language, setLanguage] = useState("th");
  // const [pages, setPages] = useState("HSRC");
  const [rid, setRid] = useState(null);

  useEffect(() => {
    // อ่าน query parameter pages จาก URL
    const params = new URLSearchParams(window.location.search);
    // const pageParam = params.get("pages") || "HSRC";
    // setPages(pageParam);

    const ridParam = params.get("rid");
    setRid(ridParam);

    // อ่าน language จาก localStorage
    const savedLang = localStorage.getItem("language") || "th";
    setLanguage(savedLang);
  }, []);

  const handleLanguageChange = lang => {
    setLanguage(lang);
    localStorage.setItem("language", lang);

    // เปลี่ยนหน้าโดยรักษา pages parameter
    const path =
      lang === "th"
        ? `/Research_detail_th?rid=${rid}`
        : `/Research_detail_en?rid=${rid}`;
    window.location.href = path;
  };

  return (
    <header className="header-container">
      {/* Top section: Logo + Language */}
      <div className="header-top">
        <div
          className="header-logo"
          onClick={() =>
            (window.location.href = `/${language === "th"
              ? "Research_detail_th"
              : "Research_detail_en"}?rid=${rid}`)}
          style={{ cursor: "pointer" }}
        >
          <img src={Logo} alt="Logo" />
        </div>

        {rid &&
          <div className="header-language">
            <span className="language-label">
              {language === "th" ? "ภาษา" : "Language"}
            </span>
            <button
              onClick={() => handleLanguageChange("th")}
              className={`lang-btn ${language === "th"
                ? "active"
                : "inactive"}`}
            >
              <img src={ThIcon} alt="ไทย" />
            </button>
            <button
              onClick={() => handleLanguageChange("en")}
              className={`lang-btn ${language === "en"
                ? "active"
                : "inactive"}`}
            >
              <img src={EnIcon} alt="English" />
            </button>
          </div>}
      </div>
    </header>
  );
};

export default Header2;
